module.exports = __webpack_public_path__ + "static/media/IMG_2080.6397c5df.JPG";